var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-calendar-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.showUpcoming
      ? _c(
          "div",
          { staticClass: "upcoming-events" },
          _vm._l(_vm.upcomingEvents, function(event) {
            return _c(
              "a",
              {
                staticClass: "upcoming-event",
                attrs: { href: "#/event/" + event.url_title }
              },
              [
                _c("div", { staticClass: "upcoming-dates" }, [
                  _c("span", { staticClass: "date-string" }, [
                    _vm._v(_vm._s(_vm.isoDate(event.raw_next_date, "MMM d")))
                  ]),
                  _vm._v(" "),
                  event.dates.length > 1
                    ? _c("span", { staticClass: "to" }, [_vm._v(" to ")])
                    : _vm._e(),
                  _vm._v(" "),
                  event.dates.length > 1
                    ? _c("span", { staticClass: "date-string" }, [
                        _vm.lastIsoDate(event, "MMM") !=
                        _vm.isoDate(event.raw_next_date, "MMM")
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.lastIsoDate(event, "MMM")) + " "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.lastIsoDate(event, "d")))
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "event-content" }, [
                  _c("h3", { domProps: { innerHTML: _vm._s(event.name) } })
                ])
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "event-calendar-filters" }, [
      _c("div", { staticClass: "event-calendar-filters-inner" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.getEvents()
              }
            }
          },
          [
            _c("div", { staticClass: "text-field keyword-search" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search.keyword,
                    expression: "search.keyword"
                  }
                ],
                attrs: { type: "text", placeholder: "KEYWORD SEARCH" },
                domProps: { value: _vm.search.keyword },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.search, "keyword", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "date-fields" }, [
              _c(
                "div",
                { staticClass: "date-field" },
                [
                  _c("datepicker", {
                    model: {
                      value: _vm.search.start_date,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "start_date", $$v)
                      },
                      expression: "search.start_date"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "date-field" },
                [
                  _c("datepicker", {
                    model: {
                      value: _vm.search.end_date,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "end_date", $$v)
                      },
                      expression: "search.end_date"
                    }
                  })
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "filter-controls" }, [
          _c(
            "a",
            {
              staticClass: "submit-search",
              on: {
                click: function($event) {
                  return _vm.getEvents()
                }
              }
            },
            [_vm._v("SEARCH")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "event-calendar-content" }, [
      _c(
        "div",
        { staticClass: "search-results" },
        [
          _vm.eventCount
            ? _c("div", { staticClass: "search-details" }, [
                _c("div", { staticClass: "search-details-left" }, [
                  _c("span", { staticClass: "search-count" }, [
                    _vm._v(_vm._s(_vm.eventCount) + " RESULTS")
                  ]),
                  _vm.search.keyword
                    ? _c("span", [_vm._v(" | " + _vm._s(_vm.search.keyword))])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "search-details-right" }, [
                  _vm.filtersActive
                    ? _c(
                        "a",
                        {
                          staticClass: "clear-search",
                          on: {
                            click: function($event) {
                              return _vm.clearSearch()
                            }
                          }
                        },
                        [
                          _vm._v("CLEAR SEARCH "),
                          _c("i", { staticClass: "mu-i-cross mu" })
                        ]
                      )
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.months, function(monthEvents, month, idx) {
            return _c("div", { staticClass: "month-group" }, [
              _c(
                "div",
                { staticClass: "month-separator", class: ["idx-" + idx] },
                [_c("h3", { domProps: { innerHTML: _vm._s(month) } })]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "event-calendar-loop" },
                _vm._l(monthEvents, function(event, idx) {
                  return _c("SingleEvent", {
                    key: "event-" + idx,
                    attrs: { event: event }
                  })
                }),
                1
              )
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "event-calendar-load-more" }, [
            _vm.filteredEvents.length > 0 &&
            _vm.filteredEvents.length < _vm.eventCount
              ? _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.loadMore()
                      }
                    }
                  },
                  [_vm._v("LOAD MORE RESULTS")]
                )
              : _vm._e()
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-section-header" }, [
      _c("h3", [_vm._v("what's happening")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", [_vm._v("SEARCH FOR EVENTS")]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "add-event-link",
          attrs: {
            href: "https://everwondr.com/events/create",
            target: "_blank"
          }
        },
        [
          _c("i", { staticClass: "fas fa-plus" }),
          _vm._v(" "),
          _c("span", [_vm._v("ADD EVENT")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "date-field-separator" }, [
      _c("span", [_vm._v("TO")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/Events.vue?vue&type=template&id=5a07a892&
// module id = 413
// module chunks = 0